import { Product } from '@axo/shared/data-access/types';
import { ApplicantDataApplicantTabPanelLayout } from './ApplicationDataApplicantTabPanelLayout';
import { DebtSection } from './Sections/DebtSection';
import { DocumentsSection } from './Sections/DocumentsSection';
import { FinanceSection } from './Sections/FinanceSection';
import { HouseholdSection } from './Sections/HouseholdSection';
import { PersonalSection } from './Sections/PersonalSection';
import { ApplicationConditionalWrapper } from '../../ConditionalWrappers/ApplicationConditionalWrapper';

interface ApplicationDataCoApplicantTabPanelProps {
  applicationID: string;
  coApplicantCustomerID: string | undefined;
  coApplicantPersonID: string | undefined;
}

export const ApplicationDataCoApplicantTabPanel: React.FC<
  ApplicationDataCoApplicantTabPanelProps
> = ({ applicationID, coApplicantCustomerID, coApplicantPersonID }) => {
  return (
    <ApplicantDataApplicantTabPanelLayout>
      <ApplicationConditionalWrapper
        whitelist={[
          { productType: [Product.UnsecuredLoan, Product.CreditCard] },
        ]}
      >
        <PersonalSection
          applicationID={applicationID}
          coApplicantCustomerID={coApplicantCustomerID}
          coApplicantPersonID={coApplicantPersonID}
        />
      </ApplicationConditionalWrapper>
      <FinanceSection
        applicationID={applicationID}
        coApplicantCustomerID={coApplicantCustomerID}
        coApplicantPersonID={coApplicantPersonID}
      />
      <HouseholdSection
        applicationID={applicationID}
        coApplicantCustomerID={coApplicantCustomerID}
        coApplicantPersonID={coApplicantPersonID}
      />
      <DebtSection
        applicationID={applicationID}
        coApplicantCustomerID={coApplicantCustomerID}
        coApplicantPersonID={coApplicantPersonID}
      />
      <ApplicationConditionalWrapper
        whitelist={[{ productType: [Product.SecuredLoan] }]}
      >
        <DocumentsSection
          applicationID={applicationID}
          coApplicantCustomerID={coApplicantCustomerID}
          coApplicantPersonID={coApplicantPersonID}
        />
      </ApplicationConditionalWrapper>
    </ApplicantDataApplicantTabPanelLayout>
  );
};
